import { faCircleMinus, faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function Faq(prop) {
  const { question, answer, id } = prop;
  const [isShowAnswer, setIsShowAnswer] = React.useState(id === 1);
  const toggleAnswer = () => setIsShowAnswer(!isShowAnswer);
  return (
    <div className="faq-container">
      <FontAwesomeIcon
        icon={isShowAnswer ? faCircleMinus : faCirclePlus}
        onClick={toggleAnswer}
        className="faq-icon"
        size="lg"
      />
      <h6 className="text-white mb-0">{question}</h6>
      <div className={`answer-container ${isShowAnswer ? 'open' : ''}`}>
        <p className="text-white">{answer}</p>
      </div>
    </div>
  );
}
